import formatImageName from 'utils/formatImageName';
import buildIllustrationImageUrl, {
  IllustrationSize,
  IllustrationOption,
} from 'utils/buildIllustrationImageUrl';
import capitalizeString from 'utils/capitalizeString';

export default function mapIllustrationProps({ file_name, image_name, tags }) {
  return {
    name: image_name.replace(/_/g, ' '),
    fileName: file_name,
    href: `/illustrations/${formatImageName(file_name)}`,
    src: buildIllustrationImageUrl(
      file_name,
      IllustrationSize.SMALL,
      IllustrationOption.SECOND_OPTION,
      true,
    ),
    alt: capitalizeString(image_name.replace(/_/g, ' ')),
    title: capitalizeString(image_name.replace(/_/g, ' ')),
    option: IllustrationOption.SECOND_OPTION,
    tags,
  };
}
